import React from "react";
import CrossIconImg from "../../assets/images/red-x-icon.svg";
function CrossIcon() {
  return <img src={CrossIconImg} alt="cross icon" />;
}

export default CrossIcon;
